import React, {useState} from "react";
import BreadcrumbsWrapper from "../../components/breadcrumbs/BreadcrumbsWrapper";
import {Container, HeaderWrapper, SelectWrapper} from "./Documentation.css";
import SwaggerUI from "swagger-ui-react";
import {Icon, Select, Tabs} from "@elcimai/webankdesignsystem";
import SwaggerCatalog from "./SwaggerManager";
import Fallback from "./Fallback";
import Sandbox from "./Sandbox";
import {getSingleValue} from "../../Utils";


function AispDocumentation(){
    const [currentTab, setCurrentTab] = useState(0);
    const catalog = SwaggerCatalog("AISP");
    const [currentVersion, setCurrentVersion] = useState(catalog[0].value);


    const tabs = [
        {
            id: 0,
            texte: "Production",
            icon: <Icon icon="Puzzle" size={16} />,
            callback: () => setCurrentTab(0),
        },
        {
            id: 1,
            texte: "Sandbox",
            icon: <Icon icon="Box" size={16} />,
            callback: () => setCurrentTab(1),
        },
        {
            id: 2,
            texte: "Fallback",
            icon: <Icon icon="Wrench" size={16} />,
            callback: () => setCurrentTab(2),
        },
    ];

    SwaggerCatalog("AISP")

    return(
        <div className={Container}>
            <BreadcrumbsWrapper/>
            <div className={HeaderWrapper}>
                <h1>Documentation AISP</h1>
                <div className={SelectWrapper}>
                    <Select name={"Version"} onChange={(value) => setCurrentVersion(getSingleValue(value))} options={catalog}
                            label={""} id={""} onBlur={undefined} value={currentVersion}/>
                </div>

            </div>
            <Tabs tabs={tabs}/>
            {(currentTab === 0) && (<SwaggerUI supportedSubmitMethods={[]} url={currentVersion}/>)}
            {(currentTab === 1) && (<Sandbox></Sandbox> ) }
            {(currentTab === 2) && ( <Fallback></Fallback>)}

        </div>
    )
}

export default AispDocumentation;